import Agent from "../services/RequestInstance";
import { ServerError } from "../utils/helpers";

import config from "../config/Config";

const BACKEND_URL = config.BACKEND_URL;

function fetchUsers(payload, cb) {
  Agent.fire("get", `${BACKEND_URL}/admin/usersList`)
    .query(payload)
    .end((err, res) => {
      var error =
        err || res.error
          ? ServerError(res)
          : res.body && res.body.error
          ? ServerError(res)
          : null;
      if (typeof cb === "function") return cb(error, res && res.body);
    });
}
function feedbacks(payload, cb) {
  Agent.fire("get", `${BACKEND_URL}/admin/feedbacks`)
    .query(payload)
    .end((err, res) => {
      var error =
        err || res.error
          ? ServerError(res)
          : res.body && res.body.error
          ? ServerError(res)
          : null;
      if (typeof cb === "function") return cb(error, res && res.body);
    });
}

function addExchange(payload, cb) {
  window.location = `${BACKEND_URL}/admin/downloadCsv`;
}

function userList(payload, cb) {
  Agent.fire("get", `${BACKEND_URL}/admin/usersList`)
    .query(payload)
    .end((err, res) => {
      var error =
        err || res.error
          ? ServerError(res)
          : res.body && res.body.error
          ? ServerError(res)
          : null;
      if (typeof cb === "function") return cb(error, res && res.body);
    });
}
function specificUserNotification(payload, cb) {
  Agent.fire("post", `${BACKEND_URL}/admin/sendPushNotificationToSpecificUser`)
    .query(payload)
    .end((err, res) => {
      var error =
        err || res.error
          ? ServerError(res)
          : res.body && res.body.error
          ? ServerError(res)
          : null;
      if (typeof cb === "function") return cb(error, res && res.body);
    });
}
function allUserNotification(payload, cb) {
  Agent.fire("post", `${BACKEND_URL}/admin/sendPushNotificationAllUsers`)
    .send(payload)
    .end((err, res) => {
      var error =
        err || res.error
          ? ServerError(res)
          : res.body && res.body.error
          ? ServerError(res)
          : null;
      if (typeof cb === "function") return cb(error, res && res.body);
    });
}
function makePremium(payload, cb) {
  Agent.fire("post", `${BACKEND_URL}/admin/makeUserPremium`)
    .query(payload)
    .end((err, res) => {
      var error =
        err || res.error
          ? ServerError(res)
          : res.body && res.body.error
          ? ServerError(res)
          : null;
      if (typeof cb === "function") return cb(error, res && res.body);
    });
}
function fetchUser(payload, cb) {
  Agent.fire("get", `${BACKEND_URL}/admin/fetchUser`)
    .query(payload)
    .end((err, res) => {
      var error =
        err || res.error
          ? ServerError(res)
          : res.body && res.body.error
          ? ServerError(res)
          : null;
      if (typeof cb === "function") return cb(error, res && res.body);
    });
}
export default {
  fetchUsers,
  feedbacks,
  addExchange,
  makePremium,
  userList,
  specificUserNotification,
  allUserNotification,
  fetchUser
};